import { section } from '@/glow';
import { AnimateImageWithFeatures } from '@/lib/animation';

section('image-with-features', {
  onLoad() {
    this.AnimateImageWithFeatures = AnimateImageWithFeatures(this.container);
  },

  onUnload() {
    this.AnimateImageWithFeatures?.destroy();
  }
});
